import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './slices/apiSlice.js';
import authSliceReducer from './slices/authSlice.js';
import quizAuthSliceReducer from './slices/fun_stuff/quizAuthSlice.js';
import logoutOn401 from './middleware/logoutOn401.js';

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authSliceReducer,
    quizAuth: quizAuthSliceReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware, logoutOn401),
  devTools: true,
})

export default store;